import { MouseEventHandler } from 'react'
import styled, { css, CSSProperties } from 'styled-components'

type Position = {
  top?: CSSProperties['top']
  right?: CSSProperties['right']
  bottom?: CSSProperties['bottom']
  left?: CSSProperties['left']
  transform?: CSSProperties['transform']
}

interface BetaPillProps {
  label: string
  color?: string
  disabled?: boolean
  isActive?: boolean
  position?: Position
}

function BetaPill(props: BetaPillProps) {
  const { label, color, disabled, isActive = false, position } = props

  return (
    <BetaPillContainer
      color={color}
      disabled={disabled}
      position={position}
      isActive={isActive}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onMouseOver={(e) => e.stopPropagation()}
      onMouseOut={(e) => e.stopPropagation()}
    >
      <BetaPillLabel data-testid="pill-label" isActive={isActive} pillColor={color}>
        {label}
      </BetaPillLabel>
    </BetaPillContainer>
  )
}

export { BetaPill }

interface BetaPillContainerProps {
  position?: Position
  disabled?: boolean
  isActive?: boolean
}

export const BetaPillContainer = styled.span<BetaPillContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 20px;
  width: 40px;
  background-color: ${({ theme, color, isActive }) =>
    isActive ? (color ?? theme.colors.yellowL0) : color ? `${color}4D` : '#635026'};
  padding: 2px 8px;

  pointer-events: none;

  ${({ position }) =>
    position &&
    css`
      position: absolute;
      top: ${
        position.top !== undefined ? (typeof position.top === 'number' ? `${position.top}px` : position.top) : 'auto'
      };
      right: ${
        position.right !== undefined
          ? typeof position.right === 'number'
            ? `${position.right}px`
            : position.right
          : 'auto'
      };
      bottom: ${
        position.bottom !== undefined
          ? typeof position.bottom === 'number'
            ? `${position.bottom}px`
            : position.bottom
          : 'auto'
      };
      left: ${
        position.left !== undefined
          ? typeof position.left === 'number'
            ? `${position.left}px`
            : position.left
          : 'auto'
      };
      transform: ${position.transform !== undefined ? position.transform : 'none'};
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `};
`

interface BetaPillLabelProps {
  isActive?: boolean
  pillColor?: string
}

export const BetaPillLabel = styled.span<BetaPillLabelProps>`
  margin: 0 4px;
  color: ${({ theme, isActive, pillColor }) =>
    isActive ? theme.colors.secondaryD3 : (pillColor ?? theme.colors.yellowL0)};
  ${({ theme }) => theme.fonts.labelSM}
`
